import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { PermissionGroup } from "../Model/PermissionGroup";

export async function deletePermissionGroup(id) {
	let response = await getAPIResponse("/v1/permission-group/"+id, {}, "DELETE");
	if (response === null) {
		return null;
	}
	let permissionGroup = PermissionGroup.createFromResponseData(response);
	return permissionGroup;
}